module.exports = __webpack_public_path__ + "static/img/2599f9db705b94ec61abcdb04d52fc9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/extract_model.png
// module id = f7Ob
// module chunks = 1